export const checklist_options = [
  // { value: "mobile", label: "Verify cell to upgrade" },
  { value: "email", label: "Email" },
  { value: "lastname", label: "Last Name" },
  { value: "picture", label: "Picture" },
  { value: "birthday", label: "Birthday" },
  { value: "address", label: "Address via Get Address" },
  { value: "profession", label: "Profession" },
  { value: "hobbies", label: "Hobbies" },
];



// WEBPACK FOOTER //
// ./src/screens/Checklist/constants/checklist.js